export function getViewerAssetsPath(): string {
  const cloudfrontEndpoint = import.meta.env.VITE_CLOUDFRONT_ENDPOINT
  return cloudfrontEndpoint
    ? `${cloudfrontEndpoint}/prizmdoc-print-14.8/viewer-assets/`
    : '/prizmdoc-print-14.8/viewer-assets/'
}
